import styled from "styled-components"
import media from "styled-media-query"

export const Parag = styled.div`
  text-align: center;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 8px;
  color: var(--gray8);
  b {
    color: var(--mainColor);
  }
`

export const Title = styled.div`
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 28px;
  color: var(--mainDarker);
  line-height: 1.1;
`
export const TitleSm = styled.div`
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 14px;
  color: var(--mainDark);
`

export const TextSm = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: var(--gray8);
  white-space: pre-wrap;
`
export const TextPCentered = styled.p`
  white-space: pre-wrap;
  text-align: center;
`

export const TextTable = styled.span`
  font-size: 16px;
  font-weight: 700;
  white-space: pre-wrap;

  ${media.greaterThan("medium")`
    font-size: 22px;
  `}
`
